module.exports = __webpack_public_path__ + "img/arrow-up.1d837be6.png";